import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, IpsecShare } from '@netfoundry-ui/shared/model';
import {
    HateoasResourceOperation,
    PagedGetOption,
} from '@lagoshny/ngx-hateoas-client';
import { tap } from 'rxjs/operators';
import { HTTP_CLIENT } from './token.service';


@Injectable({ providedIn: 'root' })
export class IpsecShareService extends HateoasResourceOperation<IpsecShare> {
    apiUrl;
    lastPageCount = 0;
    lastTotalCount = 0;

    constructor(
        @Inject(HTTP_CLIENT) private http: HttpClient,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        super(IpsecShare);
        this.apiUrl = this.environment.frontdoorURL;
    }

    public getIpsecShares(frontdoorId: string, options?: PagedGetOption): Promise<IpsecShare[]> {
        const headers = new HttpHeaders().set('Accept', 'application/hal+json');

        let params = new HttpParams().set('sort', 'createdAt,DESC');
        if (options) {
            if (options.pageParams) {
                Object.keys(options.pageParams).forEach(key => {
                    const value = options.pageParams[key];
                    if (value !== undefined && value !== null) {
                        params = params.append(key, String(value));
                    }
                });
            }

            if (options.params) {
                Object.keys(options.params).forEach(key => {
                    const value = options.params[key];
                    if (value !== undefined && value !== null) {
                        params = params.append(key, String(value));
                    }
                });
            }
        }
        return this.http
            .get<any>(`${this.apiUrl}/v2/${frontdoorId}/ipsec-shares`, {
                headers,
                params,
            })
            .pipe(
                tap((val) => {
                    this.lastPageCount = val.page.totalPages;
                    this.lastTotalCount = val.page.totalElements;
                })
            )
            .toPromise();
    }

    public getIpsecShare(frontdoorId: string, id: string) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/ipsec-shares/${id}`;
        return this.http.get(fullpath, {
            headers: { Accept: 'application/hal+json' },
        });
    }

    public create(model, frontdoorId: string) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/ipsec-shares`;
        return this.http.post(fullpath, model);
    }

    public update(model, frontdoorId: string, id: string) {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/ipsec-shares/${id}`;
        return this.http.patch(fullpath, model);
    }

    public getMetrics(frontdoorId: string, id: string, duration = '1h') {
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/ipsec-shares/${id}/metrics`;
        const params = new HttpParams().set('duration', duration);
        return this.http.get<any>(fullpath, { params });
    }

    public delete(frontdoorId: string, id: string) {
        const headers = new HttpHeaders().append('Content-Type', 'application/json');
        const fullpath = `${this.apiUrl}/v2/${frontdoorId}/ipsec-shares/${id}`;
        return this.http.delete(fullpath, { headers });
    }
}
